import Swal from "sweetalert2";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import Switch from "react-switch";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            data_member: [],
            data_brand: [],
            data_model: [],
            data_product: [],
            data_license_plate: [],
            data_job: [],
            data_invoice: [],
            data_gear_type: [
                { value: "ธรรมดา", label: "ธรรมดา" },
                { value: "ออโต้", label: "ออโต้" },
            ],

            picture: "",

            // ใบเสนอราคา
            tax_number: "",
            model_id: "",
            brand_id: "",
            member_id: "",
            address: "",
            full_name: "",
            text_number: "",
            bill_id: "",
            bill_number: "",
            record_date: new Date(), // วันที่บันทึก
            cradit_day: 0, // เครดิิต วัน
            due_date: new Date(), // ครบกำหนด
            sale_name: "", // พนักงานขาย
            entry_date: "", // วันที่เข้า
            claim_number: "", // เลขเคลม
            license_plate: "", // ทะเบียน
            gear: "", // เกียร์
            size: "", // ขนาด
            template: "", // แบบ
            chassis_number: "", // เลขตัวถัง
            machine_number: "", // เลขเครื่อง
            policy_number: "", // เลขกรมธรรม์

            remark: "",
            total_amount: 0,
            discount: 0,
            after_discount: 0,
            vat: 0,
            net_total_amount: 0,
            bill_status: 0,
            payment_type: 1,
            installments_count: "",
            installments: [],

            product_list: [],
            product_id: "",
            ref_id: "",
            level: "", // ระดับ
            qty_unit: 0, // จำนวน/หน่วย
            price_unit: 0, // ราคา/หน่วย
            total_price: 0, // ราคา

            page: 1,
            data_search: "",
            is_vat: false,

            discount_by_item:""
        }
    }
    async componentDidMount() {
        this.setState({ loading: true });
        await this.GetMemberAll();
        await this.getBrandAll();
        await this.getModelAll();
        await this.getProductAll();
        await this.GetJobAll();
        await this.GetInvoiceAll();
        if (this.props.location.query.id) {
            this.GetById(this.props.location.query.id)
        }
        this.setState({ loading: false });
    }
    GetById = async (id) => {
        let body = {
            page: 0,
            data_search: "",
            bill_id: id
        }
        let result = await GET(tokens, "v1/TH/quotation/bill/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetById:", result);
            let item = result.data;
            this.setState({
                bill_id: id,
                // ข้อมูล
                tax_number: item.tax_number,
                brand_id: item.brand_id ? { value: item.brand_id, label: item.brand_name } : "",
                model_id: item.model_id ? { value: item.model_id, label: item.model_name } : "",
                member_id: item.member_id ? { value: item.member_id, label: item.full_name, tax_number: item.tax_number } : "",
                record_date: item.record_date,
                cradit_day: item.cradit_day,
                due_date: item.due_date,
                address: item.address,
                sale_name: item.sale_name,
                entry_date: item.entry_date,
                claim_number: item.claim_number,
                license_plate: item.license_plate ? { label: item.license_plate, value: item.license_plate, member_id: item.member_id } : "",
                gear: item.gear ? { value: item.gear, label: item.gear } : "",
                size: item.size,
                template: item.template,
                chassis_number: item.chassis_number,
                machine_number: item.machine_number,
                policy_number: item.policy_number,
                payment_type: item.payment_type,
                installments_count: item.installments.length,
                installments: item.installments,

                job_number: item.job_number ? this.state.data_job.filter(e => e.label === item.job_number)[0] : "",
                invoice_number: item.invoice_number ? this.state.data_invoice.filter(e => e.label === item.invoice_number)[0] : "",
                // รวมยอด
                remark: item.remark,
                total_amount: item.total_amount,
                discount: item.discount,
                after_discount: item.after_discount,
                vat: item.vat,
                net_total_amount: item.net_total_amount,
                bill_status: item.bill_status.toString(),

                // รายการสินค้่า
                product_list: item.product_list.map(product => {
                    return {
                        product_type: product.product_id ? this.state.data_product.filter(e => e.value === product.product_id)[0].product_type : "",
                        product_id: this.state.data_product.filter(e => e.value === product.product_id)[0],
                        level: product.level,
                        qty_unit: product.qty_unit,
                        price_unit: product.price_unit,
                        total_price: product.total_price,
                        discount_by_item: product.discount_by_item,
                        csd_id: product.csd_id
                    }
                }),
                is_vat: item.vat === 0 ? false : true
            });
        }
    }
    GetMemberAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            member_id: ""
        }
        let result = await GET(tokens, "v1/TH/member-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            let data_license_plate = [];
            for (let member of result.data) {
                for (let car_list of member.car_list) {
                    data_license_plate.push({ label: car_list, value: car_list, member_id: member.member_id })
                }
            }

            console.log('member_list', result)
            this.setState({
                data_license_plate: data_license_plate,
                data_member: result.data.map(e => { return { value: e.member_id, label: e.full_name, tax_number: e.tax_number, address: e.address } })
            })
        }
    }
    getBrandAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            brand_id: ""
        }
        let result = await GET(tokens, "v1/TH/car-manage/brand/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_brand: result.data.map(e => { return { value: e.brand_id, label: e.brand_name } }) });
        }
        this.setState({ loading: false });
    }
    getModelAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            model_id: ""
        }
        let result = await GET(tokens, "v1/TH/car-manage/model/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_model: result.data.map(e => { return { value: e.model_id, label: e.model_name, brand: e.brand_id } }) });
        }
        this.setState({ loading: false });
    }
    getProductAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            product_code: ""
        }
        let result = await GET(tokens, "v1/TH/product-manage/product/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_product: result.data.map(e => { return { value: e.product_id, label: e.product_name, sell_price: e.sell_price, product_type: e.product_type } }) });
        }
    }

    GetJobAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            job_id: ""
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_job: result.data.map(e => { return { value: e.job_number, label: e.job_number, job_id: e.job_id } }) });
        }
    }
    GetInvoiceAll = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            invoice_id: ""
        }
        let result = await GET(tokens, "v1/TH/quotation/invoice/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_invoice: result.data.map(e => { return { value: e.invoice_number, label: e.invoice_number, invoice_id: e.invoice_id } }) });
        }
        this.setState({ loading: false });
    }
    GetCarById = async (id) => {
        let body = {
            page: 0,
            data_search: "",
            member_id: id
        }
        let result = await GET(tokens, "v1/TH/member-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetCar:", result)
            console.log("this.state.license_plate:", this.state.license_plate)
            let car = result.data.car_list.filter(e => e.license_plate === this.state.license_plate.value)[0];
            console.log("car:", car)
            this.setState({
                brand_id: { value: car.brand_id, label: car.brand_name },
                model_id: { value: car.model_id, label: car.model_name },
                type: car.car_type_1,
                policy_number: car.insurance_number,
                chassis_number: car.cassi_number,
                machine_number: car.engine_number,
                gear: { value: car.gear_type, label: car.gear_type }
            })
        }
    }

    GetjobById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            job_id: id
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            let item = result.data;
            this.setState({
                // ข้อมูล 
                brand_id: item.brand_name ? this.state.data_brand.filter(e => e.label === item.brand_name)[0] : "",
                model_id: item.model_name ? this.state.data_model.filter(e => e.label === item.model_name)[0] : "",
                member_id: item.member_name ? this.state.data_member.filter(e => e.label === item.member_name)[0] : "",
                entry_date: item.repair_date,
                address: item.address,
                tax_number: item.member_name ? this.state.data_member.filter(e => e.label === item.member_name)[0].tax_number : "",
                due_date: item.complete_date,
                license_plate: item.license_plate ? this.state.data_license_plate.filter(e => e.label === item.license_plate)[0] : "",

                payment_type: item.payment_type,
                installments_count: item.installments.length,
                installments: item.installments,

                type: item.car_type_1,
                policy_number: item.insurance_number,
                chassis_number: item.chassis_number,
                machine_number: item.machine_number,

                remark: "",
                total_amount: 0,
                discount: 0,
                after_discount: 0,
                vat: 0,
                net_total_amount: 0,
                is_vat: false,

                // รายการสินค้่า
                product_list: item.product_list.map(product => {
                    return {
                        product_type: product.product_id ? this.state.data_product.filter(e => e.value === product.product_id)[0].product_type : "",
                        product_id: this.state.data_product.filter(e => e.value === product.product_id)[0],
                        level: product.level ? product.level : "",
                        qty_unit: product.qty,
                        price_unit: product.estimated_price,
                        total_price: (product.qty * product.estimated_price)*((100-product.discount_by_item)/100),
                        discount_by_item:product.discount_by_item,
                        csd_id: product.csd_id ? product.csd_id : ""
                    }
                }),
            })
        }
        this.setState({ loading: false });
    }

    GetInvoiceById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            invoice_id: id
        }
        let result = await GET(tokens, "v1/TH/quotation/invoice/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetInvoiceById:", result.data);
            let item = result.data;
            this.setState({
                // ข้อมูล 
                brand_id: item.brand_id ? this.state.data_brand.filter(e => e.value === item.brand_id)[0] : "",
                model_id: item.model_id ? this.state.data_model.filter(e => e.value === item.model_id)[0] : "",
                member_id: item.member_id ? this.state.data_member.filter(e => e.value === item.member_id)[0] : "",
                entry_date: item.entry_date,
                address: item.address,
                tax_number: item.tax_number,
                due_date: item.due_date,
                license_plate: item.license_plate ? this.state.data_license_plate.filter(e => e.label === item.license_plate)[0] : "",

                payment_type: item.payment_type,
                installments_count: item.installments.length,
                installments: item.installments,

                type: "",
                policy_number: item.policy_number,
                chassis_number: item.chassis_number,
                machine_number: item.machine_number,

                remark: item.remark,
                total_amount: 0,
                discount: item.discount,
                after_discount: 0,
                vat: item.vat,
                net_total_amount: 0,
                is_vat: item.vat !== 0 ? true : false,

                // รายการสินค้่า
                product_list: item.product_list.map(product => {
                    return {
                        product_type: product.product_id ? this.state.data_product.filter(e => e.value === product.product_id)[0].product_type : "",
                        product_id: this.state.data_product.filter(e => e.value === product.product_id)[0],
                        level: product.level ? product.level : "",
                        qty_unit: product.qty_unit,
                        price_unit: product.price_unit,
                        total_price: product.total_price, 
                        discount_by_item:product.discount_by_item,
                        csd_id: product.csd_id ? product.csd_id : ""
                    }
                }),
            })
        }
        this.setState({ loading: false });
    }
    Create = async () => {
        if (this.state.payment_type === 2 && Number(toFixed(total(this.state.installments, "price")).replaceAll(",", "")) !== Number(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07)) : 0))) {
            alert("warning", "แจ้งเตือน", "ราคารวมของการแบ่งชำระ ไม่เท่ากับ จำนวนเงินทั้งสิ้น");
            return
        }
        this.setState({ loading: true });
        let body = {
            // ข้อมูล
            tax_number: this.state.tax_number,
            address: this.state.address,
            brand_id: this.state.brand_id ? this.state.brand_id.value : "",
            model_id: this.state.model_id ? this.state.model_id.value : "",
            member_id: this.state.member_id ? this.state.member_id.value : "",
            full_name: this.state.member_id ? this.state.member_id.label : "",
            record_date: this.state.record_date ? format_date(this.state.record_date, "yyyy-mm-dd", "en") : null,
            cradit_day: this.state.cradit_day,
            due_date: this.state.due_date ? format_date(this.state.due_date, "yyyy-mm-dd", "en") : null,
            sale_name: this.state.sale_name,
            entry_date: this.state.entry_date ? format_date(this.state.entry_date, "yyyy-mm-dd", "en") : null,
            claim_number: this.state.claim_number,
            license_plate: this.state.license_plate ? this.state.license_plate.value : "",
            gear: this.state.gear ? this.state.gear.value : "",
            size: this.state.size,
            template: this.state.template,
            chassis_number: this.state.chassis_number,
            machine_number: this.state.machine_number,
            policy_number: this.state.policy_number,
            payment_type: this.state.payment_type,
            installments: this.state.installments,

            job_number: this.state.job_number ? this.state.job_number.value : "",
            invoice_number: this.state.invoice_number ? this.state.invoice_number.value : "",

            // รวมยอด
            remark: this.state.remark,
            total_amount: Number(total(this.state.product_list, "total_price")),
            discount: Number(this.state.discount),
            after_discount: Number(total(this.state.product_list, "total_price") - Number(this.state.discount)),
            vat: this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07)) : 0,
            net_total_amount: Number(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07)) : 0)),
            bill_status: 1,

            // รายการสินค้่า
            product_list: this.state.product_list.map(item => {
                return {
                    product_id: item.product_id ? item.product_id.value : "",
                    level: item.level,
                    qty_unit: Number(item.qty_unit),
                    price_unit: Number(item.price_unit),
                    total_price: Number(item.total_price),
                    discount_by_item: Number(item.discount_by_item),
                }
            })
        }
        console.log("BODY:", body)
        let result = await POST(tokens, "v1/TH/quotation/bill/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/sale/list-billing");
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        if (this.state.payment_type === 2 && Number(toFixed(total(this.state.installments, "price")).replaceAll(",", "")) !== Number(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07)) : 0))) {
            alert("warning", "แจ้งเตือน", "ราคารวมของการแบ่งชำระ ไม่เท่ากับ จำนวนเงินทั้งสิ้น");
            return
        }
        this.setState({ loading: true });
        let body = {
            bill_id: this.state.bill_id,
            // ข้อมูล
            tax_number: this.state.tax_number,
            address: this.state.address,
            brand_id: this.state.brand_id ? this.state.brand_id.value : "",
            model_id: this.state.model_id ? this.state.model_id.value : "",
            member_id: this.state.member_id ? this.state.member_id.value : "",
            full_name: this.state.member_id ? this.state.member_id.label : "",
            record_date: this.state.record_date ? format_date(this.state.record_date, "yyyy-mm-dd", "en") : null,
            cradit_day: this.state.cradit_day,
            due_date: this.state.due_date ? format_date(this.state.due_date, "yyyy-mm-dd", "en") : null,
            sale_name: this.state.sale_name,
            entry_date: this.state.entry_date ? format_date(this.state.entry_date, "yyyy-mm-dd", "en") : null,
            claim_number: this.state.claim_number,
            license_plate: this.state.license_plate ? this.state.license_plate.value : "",
            gear: this.state.gear ? this.state.gear.value : "",
            size: this.state.size,
            template: this.state.template,
            chassis_number: this.state.chassis_number,
            machine_number: this.state.machine_number,
            policy_number: this.state.policy_number, payment_type: this.state.payment_type,
            installments: this.state.installments,

            job_number: this.state.job_number ? this.state.job_number.value : "",
            invoice_number: this.state.invoice_number ? this.state.invoice_number.value : "",

            // รวมยอด
            remark: this.state.remark,
            total_amount: Number(total(this.state.product_list, "total_price")),
            discount: Number(this.state.discount),
            after_discount: Number(total(this.state.product_list, "total_price") - Number(this.state.discount)),
            vat: this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07)) : 0,
            net_total_amount: Number(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? Number(toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07)) : 0)),
            bill_status: Number(this.state.bill_status),

            // รายการสินค้่า
            product_list: this.state.product_list.map(item => {
                return {
                    product_id: item.product_id ? item.product_id.value : "",
                    level: item.level,
                    qty_unit: Number(item.qty_unit),
                    price_unit: Number(item.price_unit),
                    total_price: Number(item.total_price),
                    discount_by_item: Number(item.discount_by_item),
                    csd_id: item.csd_id ? item.csd_id : ""
                }
            })
        }
        console.log("BODY:", body)
        let result = await PUT(tokens, "v1/TH/quotation/bill/update", body);
        if (result && result.status) {
            success_url("/sale/list-billing");
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>สร้างใบวางบิล : {this.state.bill_number} </b><b className="text-orange">เปิดบิลแล้ว</b></h3>
                            <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/sale/list-billing" }}>
                                <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                            </button>
                        </div>
                        <div className="row">
                            <div className="col-12 mb-2">
                                <div className="w-100 card border-0 p-3 rounded-lg">
                                    <div className="row mb-2">
                                        <div className="col-12 col-sm-6 col-md-6">
                                            <label className="mb-2">ชื่อลูกค้า:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_member}
                                                onChange={(e) => {
                                                    this.setState({
                                                        member_id: e,
                                                        license_plate: "",
                                                        brand_id: "",
                                                        model_id: ""
                                                    });

                                                    if (e) {
                                                        this.setState({ tax_number: e.tax_number, address: e.address })
                                                    } else {
                                                        this.setState({ tax_number: "", address: "" })
                                                    }
                                                }}
                                                value={this.state.member_id}
                                                isClearable
                                            ></Select>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6">
                                            <label className="mb-2">เลขที่ผู้เสียภาษี:</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ tax_number: e.target.value }) }}
                                                value={this.state.tax_number}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label className="mb-2">ที่อยู่:</label>
                                            <textarea
                                                className="form-control mb-2"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ address: e.target.value }) }}
                                                value={this.state.address}
                                                rows={3}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                                            <label className="mb-2">สำนักงาน/สาขาเลขที่:</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ branch_name: getStorage("branch").branch_name }) }}
                                                value={getStorage("branch").branch_name}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                                            <label className="mb-2">พนักงานขาย:</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ sale_name: getStorage("user").full_name }) }}
                                                value={getStorage("user").full_name}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                            <label className="mb-2">วันที่:</label>
                                            <DatePicker
                                                className="form-control mb-2"
                                                placeholder="พิมพ์คำค้นหา..."
                                                onChange={(e) => {
                                                    this.setState({ record_date: e });
                                                }}
                                                value={this.state.record_date}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                            <label className="mb-2">เครดิต (วัน):</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => {
                                                    if (!float(e.target.value)) {
                                                        return
                                                    }
                                                    this.setState({ cradit_day: Number(e.target.value) })
                                                }}
                                                value={this.state.cradit_day}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                            <label className="mb-2">วันครบกำหนดชำระ:</label>
                                            <DatePicker
                                                className="form-control mb-2"
                                                placeholder="พิมพ์คำค้นหา..."
                                                onChange={(e) => {
                                                    this.setState({ due_date: e });
                                                }}
                                                value={this.state.due_date}
                                            />
                                        </div> 
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                            <label className="mb-2">อ้างอิงใบแจ้งซ่อม:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_job}
                                                onChange={(e) => {
                                                    this.setState({ job_number: e });
                                                    if (e) {
                                                        this.GetjobById(e.job_id)
                                                    }
                                                }}
                                                value={this.state.job_number}
                                                isClearable
                                            ></Select>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                            <label className="mb-2">อ้างอิงใบแจ้งหนี้:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_invoice}
                                                onChange={(e) => {
                                                    this.setState({ invoice_number: e });
                                                    if (e) {
                                                        this.GetInvoiceById(e.invoice_id)
                                                    }
                                                }}
                                                value={this.state.invoice_number}
                                                isClearable
                                            ></Select>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col-12 col-sm-6 col-md-4">
                                            <label className="mb-2">ทะเบียน:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_license_plate.filter(e => !this.state.member_id || e.member_id === this.state.member_id.value)}
                                                onChange={(e) => {
                                                    this.setState({ license_plate: e });
                                                    if (e) {
                                                        setTimeout(() => {
                                                            this.GetCarById(e.member_id);
                                                        }, 10);
                                                    }
                                                }}
                                                value={this.state.license_plate}
                                                isClearable
                                                isDisabled={!this.state.member_id}
                                            ></Select>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4">
                                            <label className="mb-2">ยี่ห้อ:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_brand}
                                                onChange={(e) => {
                                                    this.setState({ brand_id: e, model_id: null });
                                                }}
                                                value={this.state.brand_id}
                                                isDisabled
                                            ></Select>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4">
                                            <label className="mb-2">รุ่น:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_model.filter(e => !this.state.brand_id || e.brand === this.state.brand_id.value)}
                                                onChange={(e) => {
                                                    this.setState({ model_id: e });
                                                }}
                                                value={this.state.model_id}
                                                isDisabled
                                            ></Select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="w-100 card border-0 p-0 rounded-lg" style={{ height: "100%" }}>
                                    <div>
                                        <table className="table table-borderless table-striped">
                                            <thead className="bg-primary">
                                                <tr>
                                                    <th className="text-center text-white wpx-70">ลำดับ</th>
                                                    <th className="text-center text-white">ประเภท</th>
                                                    <th className="text-left text-white">รายการ</th>
                                                    <th className="text-center text-white wpx-100">ระดับ</th>
                                                    <th className="text-center text-white wpx-80">จำนวน</th>
                                                    <th className="text-end text-white wpx-90">ราคา/หน่วย</th>
                                                    <th className="text-end text-white wpx-90">ส่วนลด %</th>
                                                    <th className="text-end text-white wpx-90">ราคารวม</th>
                                                    <th className="text-center text-white">จัดการ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.product_list && this.state.product_list.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td className="text-center">
                                                            <select className="form-control"
                                                                onChange={(e) => {
                                                                    let product_list = this.state.product_list;
                                                                    product_list[index].product_type = e.target.value;
                                                                    product_list[index].product_id = "";
                                                                    product_list[index].level = "";
                                                                    product_list[index].qty_unit = "";
                                                                    product_list[index].price_unit = "";
                                                                    product_list[index].total_price = "";
                                                                    this.setState({
                                                                        product_list: product_list
                                                                    })
                                                                }}
                                                                value={item.product_type}
                                                            >
                                                                <option value=""></option>
                                                                <option value="อะไหล่">อะไหล่</option>
                                                                <option value="การซ่อม">การซ่อม</option>
                                                            </select>
                                                        </td>
                                                        <td className="text-left">
                                                            <Select
                                                                className="form-control select-search"
                                                                styles={select_style}
                                                                options={this.state.data_product.filter(e => !item.product_type || e.product_type === item.product_type)}
                                                                onChange={(e) => {
                                                                    let product_list = this.state.product_list;
                                                                    product_list[index].product_id = e;
                                                                    if (e) {
                                                                        product_list[index].price_unit = Number(e.sell_price);
                                                                    }
                                                                    product_list[index].total_price = (Number(product_list[index].price_unit) * Number(product_list[index].qty_unit))
                                                                    this.setState({ product_list: product_list });

                                                                }}
                                                                value={item.product_id}
                                                                isClearable
                                                            ></Select>
                                                        </td>

                                                        <td className="text-center">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                placeholder=""
                                                                onChange={(e) => {
                                                                    let product_list = this.state.product_list;
                                                                    product_list[index].level = e.target.value;
                                                                    this.setState({ product_list: product_list });
                                                                }}
                                                                value={item.level}
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <input
                                                                className="form-control text-end"
                                                                type="text"
                                                                placeholder=""
                                                                onChange={(e) => {
                                                                    if (!float(e.target.value)) {
                                                                        return
                                                                    }
                                                                    let product_list = this.state.product_list;
                                                                    product_list[index].qty_unit = e.target.value;
                                                                    product_list[index].total_price = (Number(product_list[index].qty_unit) * Number(product_list[index].price_unit))*((100-Number(item.discount_by_item))/100);
                                                                    this.setState({ product_list: product_list });
                                                                }}
                                                                value={item.qty_unit}
                                                            />
                                                        </td>
                                                        <td className="text-end">
                                                            <input
                                                                className="form-control text-end"
                                                                type="text"
                                                                placeholder=""
                                                                onChange={(e) => {
                                                                    if (!float(e.target.value)) {
                                                                        return
                                                                    }
                                                                    let product_list = this.state.product_list;
                                                                    product_list[index].price_unit = e.target.value;
                                                                    product_list[index].total_price = (Number(product_list[index].qty_unit) * Number(product_list[index].price_unit))*((100-Number(item.discount_by_item))/100);
                                                                    this.setState({ product_list: product_list });
                                                                }}
                                                                value={item.price_unit}
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                                <select className="form-control"
                                                                onChange={(e)=>{
                                                                    let product_list = this.state.product_list;
                                                                    product_list[index].discount_by_item = e.target.value;
                                                                    product_list[index].total_price = (Number(product_list[index].qty_unit) * Number(product_list[index].price_unit))*((100-Number(item.discount_by_item))/100);
                                                                    this.setState({ product_list: product_list })
                                                                    
                                                                }}
                                                                value={item.discount_by_item}
                                                                >
                                                                    <option></option>
                                                                    <option value="5">5 %</option>
                                                                    <option value="10">10 %</option>
                                                                </select>
                                                                </td>
                                                        <td className="text-end">{item.total_price ? toFixed(item.total_price) : "0.00"}</td>
                                                        <td className="text-center">
                                                            <div className="w-100 d-flex justify-content-center">
                                                                <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                    onClick={() => {
                                                                        Swal.fire({
                                                                            icon: "warning",
                                                                            title: "แจ้งเตือน",
                                                                            text: "ยืนยันการลบ \"" + item.product_id.label + "\" หรือไม่ \nหากลบแล้วจะไม่สามารถย้อนคืนข้อมูลที่ลบไปได้",
                                                                            confirmButtonText: "ตกลง",
                                                                            cancelButtonText: "ยกเลิก",
                                                                            showCancelButton: true,
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                let product_list = this.state.product_list;
                                                                                product_list.splice(index, 1);
                                                                                this.setState({ product_list: product_list });
                                                                            }
                                                                        });
                                                                    }}>
                                                                    <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td className="text-center">
                                                        -
                                                    </td>
                                                    <td className="text-center">
                                                        <select className="form-control"
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    product_type: e.target.value,
                                                                    product_id: "",
                                                                    level: "",
                                                                    quantity: "",
                                                                    price_unit: ""
                                                                })
                                                            }}
                                                            value={this.state.product_type}
                                                        >
                                                            <option value=""></option>
                                                            <option value="อะไหล่">อะไหล่</option>
                                                            <option value="การซ่อม">การซ่อม</option>
                                                        </select>
                                                    </td>

                                                    <td className="text-left">
                                                        <Select
                                                            className="form-control select-search"
                                                            styles={select_style}
                                                            options={this.state.data_product.filter(e => !this.state.product_type || e.product_type === this.state.product_type)}
                                                            onChange={(e) => {
                                                                this.setState({ product_id: e });
                                                                if (e) {
                                                                    this.setState({ price_unit: Number(e.sell_price), product_type: e.product_type })
                                                                }

                                                            }}
                                                            value={this.state.product_id}
                                                            isClearable
                                                        ></Select>
                                                    </td>
                                                    <td className="text-center">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                this.setState({ level: e.target.value })
                                                            }}
                                                            value={this.state.level}
                                                        />
                                                    </td>
                                                    <td className="text-end">
                                                        <input
                                                            className="form-control text-end"
                                                            type="text"
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                if (!float(e.target.value)) {
                                                                    return
                                                                } this.setState({ quantity: Number(e.target.value) })
                                                            }}
                                                            value={this.state.quantity}
                                                        />
                                                    </td>
                                                    <td className="text-end">
                                                        <input
                                                            className="form-control text-end"
                                                            type="text"
                                                            placeholder=""
                                                            onChange={(e) => {
                                                                if (!float(e.target.value)) {
                                                                    return
                                                                }
                                                                this.setState({ price_unit: e.target.value })

                                                            }}
                                                            value={this.state.price_unit}
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                                <select className="form-control"
                                                                onChange={(e)=>{ 
                                                                    this.setState({ discount_by_item: e.target.value }) 
                                                                }}
                                                                value={this.state.discount_by_item}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="5">5 %</option>
                                                                    <option value="10">10 %</option>
                                                                </select>
                                                                </td>
                                                                <td className="text-end">{this.state.product_id ? toFixed((this.state.price_unit * Number(this.state.quantity))*((100-Number(this.state.discount_by_item))/100)) : "0.00"}</td>
                                                        <td className="text-center">
                                                        <div className="w-100 d-flex justify-content-center">
                                                            <div className="wpx-30 hpx-30 rounded-circle bg-blue text-24 text-white d-flex justify-content-center align-items-center pointer"
                                                                onClick={() => {
                                                                    if (!this.state.product_id) {
                                                                        alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                                                                        return;
                                                                    } else if (!this.state.quantity) {
                                                                        alert("warning", "แจ้งเตือน", "กรุณากรอกจำนวน");
                                                                        return;
                                                                    }
                                                                    let product_list = this.state.product_list;
                                                                    product_list.push({
                                                                        product_type: this.state.product_type,
                                                                        product_id: this.state.product_id,
                                                                        level: this.state.level,
                                                                        qty_unit: this.state.quantity,
                                                                        price_unit: this.state.price_unit,
                                                                        discount_by_item:this.state.discount_by_item,
                                                                        total_price: this.state.product_id ? (Number(this.state.price_unit) * Number(this.state.quantity))*((100-Number(this.state.discount_by_item))/100) : 0
                                                                    })
                                                                    this.setState({
                                                                        product_type: "",
                                                                        product_list: product_list,
                                                                        product_id: "",
                                                                        level: "",
                                                                        quantity: "",
                                                                        price_unit: "",
                                                                        discount_by_item:""
                                                                    })
                                                                }}>+</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="p-3 pb-0">
                                        <div className="row">
                                            <div className="col-12 col-md-7 mb-2">
                                                <label className="mb-2">หมายเหตุ :</label>
                                                <textarea
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => { this.setState({ remark: e.target.value }) }}
                                                    value={this.state.remark}
                                                    rows={5}
                                                />
                                            </div>
                                            <div className="col-12 col-md-5 mb-2">
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label>รวมเป็นเงิน</label>
                                                    <label>{toFixed(total(this.state.product_list, "total_price"))}</label>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label className="me-2">ส่วนลด</label>
                                                    <input
                                                        className="form-control text-end"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                            if (!float(e.target.value)) {
                                                                return
                                                            }
                                                            this.setState({ discount: e.target.value })
                                                        }}
                                                        value={this.state.discount}
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label>ราคาหลังหักส่วนลด</label>
                                                    <label>{toFixed(total(this.state.product_list, "total_price") - Number(this.state.discount))}</label>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <div className="d-flex align-items-center">
                                                        <Switch onChange={(e) => {
                                                            this.setState({
                                                                is_vat: e,
                                                            })
                                                        }} checked={this.state.is_vat} />
                                                        <label className="ms-2">ภาษีมูลค่าเพิ่ม 7%</label>
                                                    </div>
                                                    <label>{this.state.is_vat ? toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "") : "0.00"}</label>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <label>จำนวนเงินรวมทั้งสิ้น</label>
                                                    <label>{toFixed(total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "") : 0))}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-3">
                                        <div className="card bg-light border-0 rounded-lg mb-2">
                                            <div className="d-flex flex-wrap align-items-center p-2">
                                                <input
                                                    className="mx-1 mb-2"
                                                    type="radio"
                                                    name="type"
                                                    placeholder=""
                                                    onChange={(e) => { this.setState({ payment_type: 1, installments_count: "", installments: [] }) }}
                                                    checked={this.state.payment_type === 1}
                                                />
                                                <label className="mx-1 wpx-100 mb-2">ชำระทั้งหมด</label>
                                                <input
                                                    className="mx-1 mb-2"
                                                    type="radio"
                                                    name="type"
                                                    placeholder=""
                                                    onChange={(e) => { this.setState({ payment_type: 2, installments_count: "", installments: [] }) }}
                                                    checked={this.state.payment_type === 2}
                                                />
                                                <label className="mx-1 wpx-70 mb-2">แบ่งชำระ</label>
                                                <input
                                                    className="form-control border-0 mx-1 wpx-100 mb-2"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        if (!float(e.target.value)) {
                                                            return
                                                        }
                                                        let installments = [];
                                                        for (let i = 0; i < Number(e.target.value); i++) {
                                                            installments.push({ price: "", status: false });
                                                        }
                                                        this.setState({ installments_count: Number(e.target.value), installments: installments })
                                                    }}
                                                    value={this.state.installments_count}
                                                    readOnly={this.state.payment_type === 1}
                                                />
                                                <label className="mx-1 wpx-40 mb-2">งวด</label>
                                                {this.state.payment_type === 2 && (
                                                    <label className="d-flex align-items-center mb-2"> ราคารวม : <h4 className="px-2">{toFixed(total(this.state.installments, "price"))}</h4> บาท</label>
                                                )}
                                                {this.state.payment_type === 2 && this.state.installments.length !== 0 && (
                                                    <button
                                                        className="btn btn-primary mx-2 px-2 hpx-20 mb-2"
                                                        onClick={() => {
                                                            let price = (total(this.state.product_list, "total_price") - Number(this.state.discount) + Number(this.state.is_vat ? toFixed((total(this.state.product_list, "total_price") - Number(this.state.discount)) * 0.07).replaceAll(",", "") : 0));
                                                            let double = 0.00;
                                                            let installments = this.state.installments;
                                                            if (!toFixed(price).includes(".00")) {
                                                                double = Number("0." + toFixed(price).split(".")[1]);
                                                                price = Number(toFixed(price).split(".")[0].replaceAll(",", ""));
                                                            }
                                                            if (price % installments.length !== 0) {
                                                                double += price % installments.length;
                                                                price -= price % installments.length;
                                                            }
                                                            installments = installments.map((item, index) => { return (index === (installments.length - 1)) ? { price: (price / installments.length) + double, status: false } : { price: price / installments.length, status: false } })
                                                            this.setState({ installments: installments })

                                                        }}>
                                                        ราคาเท่ากันทุกงวด
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        <div className="row">
                                            {this.state.installments.map((item, index) => (
                                                <div className="col-12 col-md-3">
                                                    <label className="mb-2">งวดที่: {index + 1}</label>
                                                    <input
                                                        className="form-control mb-2"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                            if (!float(e.target.value)) {
                                                                return
                                                            }
                                                            let installments = this.state.installments;
                                                            installments[index].price = e.target.value;
                                                            this.setState({ installments: installments })
                                                        }}
                                                        value={item.price}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="w-100 p-3 d-flex align-items-center justify-content-end">
                                        {this.props.location.query.id && (
                                            <select
                                                className="form-control wpx-180 mx-1 mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ bill_status: e.target.value }) }}
                                                value={this.state.bill_status}
                                            >
                                                <option value="1">รออนุมัติ</option>
                                                <option value="2">อนุมัติ</option>
                                                <option value="3">ไม่อนุมัติ</option>
                                            </select>
                                        )}
                                        <button className="btn btn-outline-orange mx-1 px-5" onClick={() => { this.setState({ modal_sub_pay: true }) }}>
                                            ยกเลิก
                                        </button>
                                        <button className="btn btn-orange mx-1 px-5" onClick={() => {
                                            if (!this.state.member_id) {
                                                alert("warning", "แจ้งเตือน", "กรุณาเลือกลูกค้า");
                                                return;
                                            } else if (!this.state.license_plate) {
                                                alert("warning", "แจ้งเตือน", "กรุณาเลือกทะเบียนรถ");
                                                return;
                                            } else if (this.state.product_list.length === 0) {
                                                alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                                                return;
                                            }
                                            if (this.props.location.query.id) {
                                                this.Update()
                                            } else {
                                                this.Create()
                                            }
                                        }}>
                                            บันทึก
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
